import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { ReactElement } from 'react'
import type { WebhookProfile } from '@eggplant/types'

interface Props {
  params: WebhookProfile
  onSuccess?: () => void
  children?: () => ReactElement
}

const CreateWebhookRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/webhooks`

  const { requestParams } = useGetParamsWithSpaceId<WebhookProfile>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default CreateWebhookRequest
